import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

import HorizontalRule from '../HorizontalRule';
import FeaturedArticle from '../FeaturedArticle';

export default class FeaturedArticles extends Component {
  getFeaturedArticles() {
    if(this.props.articles && this.props.articles.length) {
      return this.props.articles.map((post) => {
        return (
          <FeaturedArticle post={post} />
        );
      });
    }

    return false;
  }

  render() {
    if(!this.props.articles || !this.getFeaturedArticles()) {
      return <div />;
    }

    const featuredArticles = this.getFeaturedArticles();

    return (
      <div className={css(styles.container)}>
        <div className={css(styles.title)}>
          Featured
        </div>
        <div className={css(styles.article_container)}>
          {
            featuredArticles[0] ? featuredArticles[0] : false
          }
          {
            featuredArticles[1] ? <HorizontalRule margin={20} /> : false
          }
          {
            featuredArticles[1] ? featuredArticles[1] : false
          }
          {
            featuredArticles[2] ? <HorizontalRule margin={20} /> : false
          }
          {
            featuredArticles[2] ? featuredArticles[2] : false
          }
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: 280,
    backgroundColor: Theme.white,
    boxSizing: 'border-box',
    padding: 15,
    marginBottom: 30,
  },
  title: {
    ontFamily: Theme.fontFamily,
    fontWeight: 900,
    color: Theme.dark_grey,
    letterSpacing: 2,
    fontSize: 10,
    textTransform: 'uppercase',
  },
  article_container: {
    marginTop: 30,
  },
})



// WEBPACK FOOTER //
// ./src/components/FeaturedArticles/index.js